import { minutesInHour, secondsInMinute } from 'helpers/timeConsts';

export default function getWorkingTime(secondsValue: number): string {
  const isNegative = secondsValue < 0;
  const absSecondsValue = Math.abs(secondsValue);
  const minutesValue = Math.floor(absSecondsValue / secondsInMinute);
  const hours = Math.floor(minutesValue / minutesInHour);
  const minutes = Math.floor(minutesValue % minutesInHour);

  const prefix = isNegative ? '-' : '';

  if (hours === 0) {
    return `${prefix}${minutes}m`;
  }

  if (minutes === 0) {
    return `${prefix}${hours}h`;
  }

  return `${prefix}${hours}h ${minutes}m`;
}
